import React from 'react';

import { Link } from 'react-router-dom';

import ModeEditTwoToneIcon from '@mui/icons-material/ModeEditTwoTone';
import IconButton from '@mui/material/IconButton';

import Image from '../../Common/Image';

const imageOptions = {
  width: 300,
};

type Props = {
  offer: {
    result: App.Offer & { panel_cloudinary_id?: string };
  };
};

export default function PanelImagePane({ offer }: Props) {
  const { id_salesforce_external, panel_cloudinary_id } = offer.result;

  return (
    <span>
      <h1>
        <Link to={'/edit-offers/' + id_salesforce_external}>
          <IconButton aria-label="Edit">
            <ModeEditTwoToneIcon fontSize="large" />
          </IconButton>
        </Link>
      </h1>
      {panel_cloudinary_id && (
        <Image className="img-responsive img-thumbnail" publicId={panel_cloudinary_id} options={imageOptions} />
      )}
    </span>
  );
}
